import { styled } from '../../Styles/stitches.config'

export const CategoryHeader = styled('div', {
    borderBottom: '1px solid $primary600',
    color: '$primary600',
    fontSize: 18,
    fontWeight: 600,
})

export const StyledLeksikonCategory = styled('div', {
    display: 'grid',
    gap: '$1',
})
